import { usePromotePageState } from 'src/app/pages/promote/pageContext';

type Props = {
	type: 'selection' | 'custom';
};
export function useValidationError({ type }: Props): { error: string | undefined } {
	const [{ validationErrors }] = usePromotePageState();

	return { error: type === 'selection' ? validationErrors?.amountSelection : validationErrors?.customAmount };
}
